import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { useApp, API } from "@/context/AppContext";
import ProductCard from "@/components/ProductCard";

// Best-effort localized category name: prefer frontend i18n key, then backend name[lang],
// then backend name.en, then backend name.de, else prettify the slug.
function catName(c, t, lang) {
  const slugKey = "cat_" + (c.slug || "").replace(/-/g, "_");
  const fromT = t(slugKey);
  if (fromT && fromT !== slugKey) return fromT;
  return c.name?.[lang] || c.name?.en || c.name?.de || (c.slug || "").replace(/-/g, " ");
}

export default function Shop() {
  const { category } = useParams();
  const { t, lang } = useApp();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const url = category ? `${API}/products?category=${category}` : `${API}/products`;
    axios.get(url).then(r => setProducts(r.data));
    axios.get(`${API}/categories`).then(r => setCategories(r.data));
  }, [category]);

  const currentCat = categories.find(c => c.slug === category);

  return (
    <div className="container-narrow py-16">
      <div className="mb-10">
        <div className="eyebrow mb-3">{t("nav_shop")}</div>
        <h1 className="font-serif-display text-4xl sm:text-6xl text-white" data-testid="shop-title">
          {currentCat ? catName(currentCat, t, lang) : t("nav_shop")}
        </h1>
      </div>

      {/* Category filter */}
      <div className="flex flex-wrap gap-2 mb-10 border-b border-white/10 pb-6">
        <Link
          to="/shop"
          className={`px-4 py-2 text-[11px] tracking-[0.2em] uppercase border transition-colors ${!category ? "border-gold text-gold" : "border-white/15 text-white/70 hover:border-gold hover:text-gold"}`}
          data-testid="filter-all"
        >
          {t("view_all")}
        </Link>
        {categories.map(c => (
          <Link
            key={c.slug}
            to={`/shop/${c.slug}`}
            data-testid={`filter-${c.slug}`}
            className={`px-4 py-2 text-[11px] tracking-[0.2em] uppercase border transition-colors ${category === c.slug ? "border-gold text-gold" : "border-white/15 text-white/70 hover:border-gold hover:text-gold"}`}
          >
            {catName(c, t, lang)}
          </Link>
        ))}
      </div>

      {products.length === 0 ? (
        <div className="text-white/60 py-20 text-center">—</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {products.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
